import { gql, QueryResult, useQuery } from "@apollo/client";

import { LanguageRegionQuery } from "../../generated/gql/graphql";

const GET_LANGUAGE_REGIONS = gql`
  query Items($query: LanguageRegionQuery) {
    languageRegions(query: $query) {
      items {
        id
        status
        name
        sort
        dateCreated
        dateUpdated
      }
    }
  }
`;

export default function useLanguageRegions(
  query?: LanguageRegionQuery
): QueryResult<LanguageRegionQuery> {
  return useQuery(GET_LANGUAGE_REGIONS, {
    variables: {
      query,
    },
  });
}
